export class SafeContextException extends Error {
  public message = 'Context Provider not found';
}
